import isObject from "./is-object.js";

const merge = (...args) => {
  let target = {};

  const merger = (obj) => {
    Object.keys(obj).forEach((key) => {
      target[key] =
        isObject(obj[key]) && isObject(target[key]) ? merge(target[key], obj[key]) : obj[key];
    });
  };

  for (let i = 0; i < args.length; i++) {
    if (!isObject(args[i])) {
      throw new Error("Incoming data is not an object");
    }

    merger(args[i]);
  }

  return target;
};

export default merge;
